module.exports = __webpack_public_path__ + "static/media/Introduction to Logic.3e893a5c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PHIL/Introduction to Logic.pdf
// module id = 156
// module chunks = 0